module.exports = __webpack_public_path__ + "static/media/vase4.f0a44ba6.jpg";